"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NounsSeeder__factory = void 0;
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
const ethers_1 = require("ethers");
const _abi = [
    {
        inputs: [
            {
                internalType: "uint256",
                name: "nounId",
                type: "uint256",
            },
            {
                internalType: "contract INounsDescriptorMinimal",
                name: "descriptor",
                type: "address",
            },
        ],
        name: "generateSeed",
        outputs: [
            {
                components: [
                    {
                        internalType: "uint48",
                        name: "background",
                        type: "uint48",
                    },
                    {
                        internalType: "uint48",
                        name: "body",
                        type: "uint48",
                    },
                    {
                        internalType: "uint48",
                        name: "accessory",
                        type: "uint48",
                    },
                    {
                        internalType: "uint48",
                        name: "head",
                        type: "uint48",
                    },
                    {
                        internalType: "uint48",
                        name: "glasses",
                        type: "uint48",
                    },
                ],
                internalType: "struct INounsSeeder.Seed",
                name: "",
                type: "tuple",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
];
const _bytecode = "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";
const isSuperArgs = (xs) => xs.length > 1;
class NounsSeeder__factory extends ethers_1.ContractFactory {
    constructor(...args) {
        if (isSuperArgs(args)) {
            super(...args);
        }
        else {
            super(_abi, _bytecode, args[0]);
        }
    }
    deploy(overrides) {
        return super.deploy(overrides || {});
    }
    getDeployTransaction(overrides) {
        return super.getDeployTransaction(overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new ethers_1.utils.Interface(_abi);
    }
    static connect(address, signerOrProvider) {
        return new ethers_1.Contract(address, _abi, signerOrProvider);
    }
}
exports.NounsSeeder__factory = NounsSeeder__factory;
NounsSeeder__factory.bytecode = _bytecode;
NounsSeeder__factory.abi = _abi;
